"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NounsSeeder__factory = void 0;
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
const ethers_1 = require("ethers");
const _abi = [
    {
        inputs: [
            {
                internalType: "uint256",
                name: "nounId",
                type: "uint256",
            },
            {
                internalType: "contract INounsDescriptorMinimal",
                name: "descriptor",
                type: "address",
            },
        ],
        name: "generateSeed",
        outputs: [
            {
                components: [
                    {
                        internalType: "uint48",
                        name: "background",
                        type: "uint48",
                    },
                    {
                        internalType: "uint48",
                        name: "body",
                        type: "uint48",
                    },
                    {
                        internalType: "uint48",
                        name: "accessory",
                        type: "uint48",
                    },
                    {
                        internalType: "uint48",
                        name: "head",
                        type: "uint48",
                    },
                    {
                        internalType: "uint48",
                        name: "glasses",
                        type: "uint48",
                    },
                ],
                internalType: "struct INounsSeeder.Seed",
                name: "",
                type: "tuple",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
];
const _bytecode = "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";
const isSuperArgs = (xs) => xs.length > 1;
class NounsSeeder__factory extends ethers_1.ContractFactory {
    constructor(...args) {
        if (isSuperArgs(args)) {
            super(...args);
        }
        else {
            super(_abi, _bytecode, args[0]);
        }
    }
    deploy(overrides) {
        return super.deploy(overrides || {});
    }
    getDeployTransaction(overrides) {
        return super.getDeployTransaction(overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new ethers_1.utils.Interface(_abi);
    }
    static connect(address, signerOrProvider) {
        return new ethers_1.Contract(address, _abi, signerOrProvider);
    }
}
exports.NounsSeeder__factory = NounsSeeder__factory;
NounsSeeder__factory.bytecode = _bytecode;
NounsSeeder__factory.abi = _abi;
